<template>
  <div id="upload-point-info">
    <b-card no-body class="container-card p-2 card-create">
      <b-form @submit.prevent="onSubmit">
        <b-row >
          <b-col>
            <div>
              <b-col cols="12">
                <span class="information-header">
                  {{ isComfirm || isPreview ? " Preview Data" : "Camplaign" }}
                </span>
              </b-col>
              <b-col cols="12" class="mt-1">
                <b-row>
                  <b-col cols="3" md="auto" class="mt-1">
                    <div >
                      <label for="reference-Code" class="required font-medium-5">
                         Reference Code
                      </label>
                    </div>
                  </b-col>
                  <b-col cols="5" class="mt-1">
                    <v-select
                      v-model="formData.refCode"
                      :searchable="true"
                      class="upload-point-select bg-dropdown"
                      :label="'asset'"
                      placeholder="--Select--"
                      :reduce="(option) => option.assetid"
                      :options="refCodeOption.refCode"
                      :disabled="isComfirm || isPreview"
                      required
                      :clearable="false"
                    >
                      <template #search="{attributes, events}">
                        <input
                          class="vs__search"
                          :required="!formData.refCode"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                    </v-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="mt-1" v-if="formData.CamplaignRef">
                <b-row>
                  <b-col cols="3" md="auto" class="mt-1 ">
                    <div class="font-medium-5">
                      Camplaign Reference
                    </div>
                  </b-col>
                  <b-col cols="5" class="mt-1">
                    <b-form-input
                      id="campaign-ref"
                      v-model="formData.CamplaignRef"
                      disabled
                      class="textbox-input"
                      :style="'width : 210px'"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <div v-if="isCreate || isEdit">
                <b-col cols="12" class="mt-1">
                  <label for="campaign-name" class="required font-medium-5">
                    Campaign Name
                  </label>
                  <b-form-input
                    id="campaign-name"
                    v-model="formData.campaignName"
                    required
                    class="textbox-input"
                  />
                </b-col>
                <b-col cols="12" class="mt-1">
                  <label for="desription" class="font-medium-5">
                    Description
                  </label>
                  <b-form-textarea
                    id="description"
                    v-model="formData.description"
                    class="textbox-input"
                    :max-rows="4"
                    :rows="4"
                  />
                </b-col>
              </div>
              <div v-else>
                <b-col cols="12" class="mt-1">
                  <b-row>
                    <b-col cols="2" class="mt-1">
                      <div class="font-medium-5">
                        Campaign Name
                      </div>
                    </b-col>
                    <b-col cols="10" class="mt-1">
                      <b-form-input
                        id="campaign-name"
                        v-model="formData.campaignName"
                        disabled
                        class="textbox-input"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="mt-1">
                  <b-row>
                    <b-col cols="2" class="mt-1">
                      <div class="font-medium-5">
                        Description
                      </div>
                    </b-col>
                    <b-col cols="10" class="mt-1">
                      <b-form-textarea
                        id="description"
                        v-model="formData.description"
                        disabled
                        class="textbox-input"
                        :max-rows="4"
                        :rows="4"
                      />
                    </b-col>
                  </b-row>
                </b-col>
              </div>
              <b-col cols="12" class="d-flex justify-content-end mt-2">
                <save-button
                  class="ml-1 mr-3"
                  v-if="isEdit || isCreate"
                  :type="'submit'"
                />
                <b-button class="next-button" 
                  :class="[!isNext ? 'active' : '']"
                  :disabled="isNext"
                  v-if="isEdit" 
                  @click="onNextStep"
                >
                  <span class="mr-25 align-middle">Next</span>
                </b-button>
              </b-col>
            </div>
          </b-col>
          <b-col>
            <div
              class="container-card upload-point-card p-2 mb-1"
              v-if="isCreate || isEdit"
            >
              <b-col cols="12">
                <span class="information-header">Upload Point</span>
              </b-col>
              <div v-if="isCreate">
                <b-col cols="12">
                  <div
                    class="d-flex justify-content-center no-img-table-render"
                    :style="'300px'"
                  >
                    <img
                      class="h-100"
                      :src="uploadfileImg"
                      alt=""
                      draggable="false"
                    />
                  </div>
                  <div class="mt-1 text-center">
                    <label class="empty-color font-medium-3"
                      >Create a campaign name and save for upload excel
                      file.</label
                    >
                  </div>
                </b-col>
              </div>
              <div v-else-if="isEdit">
                <b-col cols="12">
                  <div
                    class="text-upload mt-1 text-start font-medium-3"
                    style="padding-bottom: 15px"
                    v-safe-html="
                      textUpload.textHeader[0].text +
                        textUpload.textHeader[1].text
                    "
                  ></div>
                  <div class="d-flex justify-content-center ">
                    <upload-csv-file
                      :file="formData.fileUpload"
                      :templateUrl="formData.templateUrl"
                      :acceptFile="'.csv'"
                      @onInputFile="onInputFile"
                    />
                  </div>
                  <div
                    class="text-upload mt-1 text-start font-medium-3"
                    style="padding-top: 15px"
                    v-safe-html="
                      textUpload.textFooter[0].text +
                        textUpload.textFooter[1].text
                    "
                  ></div>
                </b-col>
              </div>
            </div>
            <div v-else>
              <b-col cols="12">
                <span class="information-header">Summary Data</span>
              </b-col>
              <b-col cols="12" class="mt-1">
                <b-row>
                  <b-col cols="2" class="mt-1">
                    <div class="font-medium-5">
                      Total Users
                    </div>
                  </b-col>
                  <b-col cols="10" class="mt-1">
                    <b-form-input
                      id="total-users"
                      v-model="formData.totalUsers"
                      disabled
                      class="textbox-input"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" class="mt-1">
                <b-row>
                  <b-col cols="2" class="mt-1">
                    <div class="font-medium-5">
                      Total Point
                    </div>
                  </b-col>
                  <b-col cols="10" class="mt-1">
                    <b-form-input
                      id="total-users"
                      v-model="formData.totalPoint"
                      disabled
                      class="textbox-input"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="isComfirm || isPreview">
          <b-col>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <save-button v-if="isPreview"
                  class="ml-1"
                  @click.native="onSubmitExport"
                  :btnLabel="'Export CSV.'"
                />
              </div>
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </b-col>
          <b-col cols="12" class="mb-1">
            <overlay-loading :loading="loading.tableData">
              <template #content>
                <b-table
                  :fields="fields"
                  :items="previewDataListTable.payload"
                  @sort-changed="sortingChanged"
                  responsive
                  bordered
                  borderless
                  sticky-header
                  show-empty
                  class="default-static-table text-center "
                >
                  <template #cell(seq)="data">
                    <span>{{ data.index + 1 }}</span>
                  </template>
                  <template #cell(status)="data">
                    <div class="d-flex align-items-center justify-content-center">
                      <div
                        class="upload-point-status text-center"
                        :class="[resolveClassUploadPointInfoStatus(data.item.status)]"
                      >
                        {{ resolveUploadPointInfoStatus(data.item.status) }}
                      </div>
                    </div>
                  </template>
                  <template #cell(message_th)="data">
                    <div class="d-flex align-items-start justify-content-start">
                      {{ data.item.message_th }}
                    </div>
                  </template>
                  <template #empty>
                    <card-no-item :text-no-img="'Item Not Found'" />
                  </template>
                </b-table>
              </template>
            </overlay-loading>
          </b-col>
          <b-col>
            <div class="d-flex flex-wrap justify-content-center" v-if="isComfirm">
              <save-button
                class="ml-1"
                @click.native="onSubmitConfirm"
                :btnLabel="'Comfirm'"
              />
            </div>
          </b-col>
          <b-col cols="12">
            <pagination-with-reorder
              entity-editable
              :pagination="pagination"
              @entityChange="onFilterEntity"
              @pageChange="onPageChange"
            />
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";
import Search from "@/views/components/search/Search.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";

import uploadfileImg from "@/assets/images/artwork/upload-file.png";
import useUploadPointinfo from "@/views/pages/ais-point/upload-point/upload-point-info/hooks/useUploadPointInfo";

import UploadCsvFile from "@/views/pages/ais-point/upload-point/upload-point-info/components/UploadCSVFile.vue";
const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

const sortableRow = {
  name: "sortableRow",
  bind(el, binding, vnode) {
    const table = el;
    table._sortable = createSortable(
      table.querySelector("tbody"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    sortableRow,
  },
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    Search,
    OverlayLoading,
    PaginationWithReorder,
    vSelect,
    UploadCsvFile,
  },
  setup() {
    const {
      loading,
      fields,
      formData,
      isCreate,
      isEdit,
      isComfirm,
      isPreview,
      isNext,
      textUpload,
      previewDataListTable,
      refCodeOption,
      pagination,
      onPageChange,
      onFilterEntity,
      sortingChanged,
      onSetValueSearch,
      onSelectFilter,
      onSubmit,
      onSubmitExport,
      onSubmitConfirm,
      onInputFile,
      onNextStep,
      resolveUploadPointInfoStatus,
      resolveClassUploadPointInfoStatus,
    } = useUploadPointinfo();

    return {
      loading,
      fields,
      formData,
      isCreate,
      isEdit,
      isComfirm,
      isPreview,
      isNext,
      textUpload,
      previewDataListTable,
      refCodeOption,
      pagination,
      onPageChange,
      onFilterEntity,
      sortingChanged,
      onSetValueSearch,
      onSelectFilter,
      onSubmit,
      onSubmitExport,
      onSubmitConfirm,
      onInputFile,
      onNextStep,
      resolveUploadPointInfoStatus,
      resolveClassUploadPointInfoStatus,
      
      uploadfileImg,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
@import "~@/assets/css/pages/exchange/ais-point/upload-point-info.css";
</style>
